// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".RUVjCQhfHQmwmqRgPzSS{text-align:center}.xNjg2ni6yO6xk_FOkj8u{width:50%;height:auto}._15OLJYtL5mihyczWPS2w{font-family:var(--font1);margin-top:3rem}.Gxe1KCevBpSUu4ZPA_aY{font-weight:700}.xUNEiNVecQcSAnmgaeej{font-size:.875rem;color:var(--color4, #666);margin-top:1rem;text-align:left}.xUNEiNVecQcSAnmgaeej a{text-decoration:underline}.HAIzlbE7AKNjvtwrRTAg{background:#fecc00}.HAIzlbE7AKNjvtwrRTAg:hover:not(:disabled){background:#eabb00}.FES9zfndyshL491dyKhZ{opacity:.6;cursor:not-allowed;background:#ececec}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": "RUVjCQhfHQmwmqRgPzSS",
	"image": "xNjg2ni6yO6xk_FOkj8u",
	"description": "_15OLJYtL5mihyczWPS2w",
	"checkboxLabelText": "Gxe1KCevBpSUu4ZPA_aY",
	"legalText": "xUNEiNVecQcSAnmgaeej",
	"submitButton": "HAIzlbE7AKNjvtwrRTAg",
	"buttonDisabled": "FES9zfndyshL491dyKhZ"
};
export default ___CSS_LOADER_EXPORT___;
